import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 51.498 51.498"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Group 4220" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8018",
    d: "M46.022 39.3 26.129 4.137a2.295 2.295 0 0 0-3.956 0L2.28 39.3a2.2 2.2 0 0 0 1.978 3.26h39.786a2.2 2.2 0 0 0 1.978-3.26zm-40.165.1L24.151 7.064 42.445 39.4z",
    style: {"fill":"#f7aa42"},
    transform: "translate(-2.008 -3.005)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8019",
    d: "M18.165 10H15v14.243h3.165z",
    transform: "translate(5.561 1.07)",
    style: {"fill":"#f7aa42"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8020",
    d: "M16.874 25.748a2.374 2.374 0 1 0-2.374-2.374 2.374 2.374 0 0 0 2.374 2.374z",
    transform: "translate(5.269 7.478)",
    style: {"fill":"#f7aa42"}
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };